<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Email template</h1>
          <p class="mt-2 text-sm text-gray-700">{{ emailTemplateData.name }}</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none w-1/3">
          <div class="mt-2">
              <v-select
                  v-model="account_id"
                  :reduce="item => item.id"
                  :options="accountList"
                  label="name"
                  placeholder="View for account"
                  searchable
              />
          </div>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="cancel" type="button" class="pull-right block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Back</button>
        </div>
        <div class="mt-4 sm:ml-2 sm:mt-0 sm:flex-none">
          <button @click="testSend" type="button" class="pull-right block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Test send</button>
        </div>
      </div>
      <div>
        <div class="overflow-hidden rounded-lg bg-gray-50 m-2">
          <div class="px-4 py-5 sm:p-6">
            <div class="px-4 sm:px-0">
              <h2 class="text-base font-semibold leading-7 text-gray-900">Subject</h2>
              <p class="mt-1 text-sm leading-6 text-gray-600">{{ emailTemplateData.subject }}</p>
            </div>
            <div class="px-4 sm:px-0">
              <h2 class="text-base font-semibold leading-7 text-gray-900">Available dynamic content</h2>
              <p v-for="(dynamicContent, dynamicContentName) in emailTemplateData.dynamic_contents" :key="dynamicContentName" class="mt-1 text-sm leading-6 text-gray-600">##{{dynamicContentName}}##</p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="relative">
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-gray-300" />
          </div>
          <div class="relative flex justify-center">
            <button @click="openEmailContentModal(null)" type="button" class="inline-flex items-center gap-x-1.5 rounded-full bg-white px-3 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
              <PlusIcon class="-ml-1 -mr-0.5 h-5 w-5 text-gray-400" aria-hidden="true" />
              Add content
            </button>
          </div>
        </div>

        <iframe
            ref="iframe"
            :srcdoc="emailTemplateData.email_template"
            style="width: 100%; height: 600px; border: none;">
        </iframe>

      </div>
    </div>
  </div>
</template>

<script>

import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";
import EmailTemplateEditFormComponent from "../Email/EmailTemplateEditFormComponent.vue";
import { PlusIcon } from '@heroicons/vue/20/solid'

export default {
  name: "EmailTemplateShowComponent",
  data() {
    return {
      emailTemplateData: {},
      isListenerAdded: false,
      emailTemplateContentCurrent: {},
      accountList: [],
      account_id: null,
    };
  },
  computed: {
    emailTemplateId() {
      return this.$route.params.id ? parseInt(this.$route.params.id) : null;
    },
  },
  components: {
    EmailTemplateEditFormComponent,
    PlusIcon,
  },
  watch: {
    account_id(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onAccountChange();
      }
    },
  },
  methods: {
    getEmailTemplate(account_id = null) {
      let path = `/member-firm/email-templates/show/${this.emailTemplateId}`;

      if (account_id) {
        path = `/member-firm/email-templates/show/${this.emailTemplateId}/${account_id}`;
      }

      axios.get(path)
          .then((res) => {
            this.emailTemplateData = res.data.data;
          })
          .catch((error) => {
            console.log("error", error);
          });
    },
    handleIframeMessage(event) {
      if (event.data.type === 'elementClick') {
        this.openEmailContentModal(parseInt(event.data.dataId));
      }

      if (event.data.type === 'resizeImage') {

        let formData = {
          content_css: {
            width: event.data.width,
            height: event.data.height,
          }
        };

        this.updateCssParams(event.data.dataId, formData)
      }

      if (event.data.type === 'reorderItems') {
        let formData = {
          order_items: event.data.order
        };

        this.reorderTemplateContents(formData)
      }
    },
    updateCssParams(dataId, formData) {
      axios.post(
          `/member-firm/email-templates/update-css-params/${dataId}`,
          formData,
          {
            headers: {'Content-Type': 'multipart/form-data'},
            params: {_method: 'PUT'}
          }
      ).then((res) => {
        this.getEmailTemplate();
        this.$notify({ type: "success", title: "Successfully", text: res.data.message });
        this.$emit('cancel');
      }).catch((error) => {
        console.log('error', error);
        this.getEmailTemplate();
        this.$notify({ title: "Unsuccessfully", text: error.message });
      });
    },
    reorderTemplateContents(formData) {
      axios.post(
          `/member-firm/email-templates/reorder-items/${this.emailTemplateId}`,
          formData,
          {
            headers: {'Content-Type': 'multipart/form-data'},
            params: {_method: 'PUT'}
          }
      ).then((res) => {
        this.getEmailTemplate();
        this.$notify({ type: "success", title: "Successfully", text: res.data.message });
        this.$emit('cancel');
      }).catch((error) => {
        console.log('error', error);
        this.getEmailTemplate();
        this.$notify({ title: "Unsuccessfully", text: error.message });
      });
    },
    cancel() {
      this.$router.back();
    },
    openEmailContentModal(dataId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: EmailTemplateEditFormComponent,
            attrs: {
              dataId: dataId,
              emailTemplateId: this.emailTemplateId,
              onReloadIndex() {
                self.getEmailTemplate();
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
    testSend() {
      axios.get(
          `/member-firm/email-templates/send-template-test/${this.emailTemplateId}`
      ).then((res) => {
        this.$notify({ type: "success", title: "Successfully", text: res.data.message });
      }).catch((error) => {
        console.log("error", error);
        this.$notify({ title: "Unsuccessfully", text: error.message });
      });
    },
    getAccountsList() {
      axios.get(`/member-firm/user/form-data/accounts-list`).then((res) => {
        this.accountList = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    onAccountChange() {
      this.getEmailTemplate(this.account_id);
    },
  },
  mounted() {
    if (this.emailTemplateId) {
      this.getEmailTemplate();
    }

    if (!this.isListenerAdded) {
      window.addEventListener("message", this.handleIframeMessage);
      this.isListenerAdded = true;
    }
  },
  beforeUnmount() {
    if (this.isListenerAdded) {
      window.removeEventListener("message", this.handleIframeMessage);
      this.isListenerAdded = false;
    }
  },
  created() {
    this.getAccountsList();
  },
};
</script>
